/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2Claim/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2Claim({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2Claim",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 14,
  height = 14,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#3B95E7"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2Claim.Svg"
  data-view-path={viewPath}
 viewBox="0 0 14 14"
 style={{'--as-1-Z2jDWgc': alignSelf,'--mt-2-Z2jDWgc': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Z2jDWgc': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Z2jDWgc': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Z2jDWgc': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Z2jDWgc': opacity,'--w-10-Z2jDWgc': typeof width === 'number' ? `${width}px` : width,'--h-11-Z2jDWgc': typeof height === 'number' ? `${height}px` : height,'--f-12-Z2jDWgc': fill,'--a-7-Z2jDWgc': isAnimated ? animation : "none",'--sd-8-Z2jDWgc': isAnimated ? strokeDashoffset : 0,'--sd-9-Z2jDWgc': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2Claim.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M.732.732A2.5 2.5 0 012.5 0H12a2 2 0 012 2v3.5a.5.5 0 01-.5.5h-1.245V2.5a.625.625 0 10-1.25 0V6H11v7.5a.5.5 0 01-.757.429L8 12.583 5.757 13.93a.5.5 0 01-.514 0L3 12.583.757 13.93A.5.5 0 010 13.5v-11A2.5 2.5 0 01.732.732zM5.5 2a.75.75 0 01.75.75v.528a1.999 1.999 0 011.553 1.305.75.75 0 01-1.415.5.5.5 0 00-.471-.333h-.968a.366.366 0 00-.078.723l1.473.322a2 2 0 01-.094 3.927v.528a.75.75 0 01-1.5 0v-.528a2.003 2.003 0 01-1.553-1.305.75.75 0 111.415-.5.5.5 0 00.471.333h.834a.5.5 0 00.107-.99L4.55 6.939a1.866 1.866 0 01.2-3.678v-.51A.75.75 0 015.5 2z"
 style={{'--f-12-Z2jDWgc': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}